import React from "react";

import useSecuritiesBySecurityIds from "@fartherfinance/frontend/api/SecurityMaster/hooks/useSecuritiesBySecurityIds";
import { SecurityId } from "@fartherfinance/frontend/api/Types";

import useAdvisorRequestAuth from "@src/multiCustodian/hooks/useAdvisorRequestAuth";
import useRequestAuth from "@src/multiCustodian/hooks/useRequestAuth";
import { toClassName } from "@src/multiCustodian/utils/to-class-name";
import Skeleton from "@src/sharedComponents/Skeleton/Skeleton";
import displayTitleFromSecurity from "@src/utils/displayTitleFromSecurity";

import styles2 from "./HypotheticalHoldingsWeightsTable.module.css";
import styles from "../basicTable.module.css";

interface Props {
  securityId: SecurityId;
  current: string;
  target: string;
  withTaxBudget: string;
  withoutTaxBudget: string;
  difference: string;
}

const SecuritiesRowV2: React.FC<Props> = (props) => {
  const auth = useRequestAuth();
  const advisorAuth = useAdvisorRequestAuth();

  const { data, isLoading } = useSecuritiesBySecurityIds(
    [props.securityId],
    auth ?? advisorAuth
  );

  const [securityData] = data ?? [];

  return (
    <tr className={toClassName(styles.row)}>
      <td className={toClassName(styles.cell, styles2.textAlignLeft)}>
        {isLoading ? (
          <Skeleton width={80} />
        ) : (
          displayTitleFromSecurity(securityData)
        )}
      </td>

      <td className={toClassName(styles.cell, styles2.textAlignRight)}>
        {props.current}
      </td>

      <td className={toClassName(styles.cell, styles2.textAlignRight)}>
        {props.target}
      </td>

      <td className={toClassName(styles.cell, styles2.textAlignRight)}>
        {props.withoutTaxBudget}
      </td>

      <td className={toClassName(styles.cell, styles2.textAlignRight)}>
        {props.withTaxBudget}
      </td>

      <td className={toClassName(styles.cell, styles2.textAlignRight)}>
        {props.difference}
      </td>
    </tr>
  );
};

export default SecuritiesRowV2;
